import { render, staticRenderFns } from "./accountdialog.vue?vue&type=template&id=5fbd1857&scoped=true"
import script from "./accountdialog.vue?vue&type=script&lang=js"
export * from "./accountdialog.vue?vue&type=script&lang=js"
import style0 from "./accountdialog.vue?vue&type=style&index=0&id=5fbd1857&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd1857",
  null
  
)

export default component.exports